import React, { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import ModuleComingSoon from "../components/shared/ModuleComingSoon";

// Shown for a module whose page file is missing or empty (see utils/pageRegistry.js): the module is looked up by
// the URL and an "Under work — coming soon" page is drawn, in the same theme as every other page.
export default function GenericModulePage() {
  const { pathname } = useLocation();
  const modules = useSelector((s) => s.auth.modules);
  const mod = useMemo(() => (modules || []).find((m) => String(m.route_path || "").trim() === pathname) || null, [modules, pathname]);
  return <ModuleComingSoon name={mod?.name?.trim() || "This page"} side={pathname.startsWith("/admin") ? "admin" : "customer"} />;
}
